export default __webpack_public_path__ + "static/media/spines.5dad5691.png";